<script>
import options from './HoldetsDeltagere.options'
export default options
</script>

<template>
  <article class="kb-holdets-deltagere">
    <div class="kb-holdets-deltagere__header">
      <h2 class="kb-holdets-deltagere__title">
        {{ getLabel('title') }} ({{ participantList.length }})
      </h2>
      <a
        :href="`mailto:?subject=${getLabel('sendMailSubject')}&body=${getLabel('sendMailBody')}`"
        class="kb-link"
      >
        {{ getLabel('invite') }}</a
      >
    </div>
    <div
      class="kb-holdets-deltagere__header kb-holdets-deltagere__header--left-align"
    >
      <template v-if="addDeltagerFormUrl">
        <a
          :href="addDeltagerFormUrl"
          @keydown.tab="tabTrap"
          data-order="first"
          class="kb-button"
          >{{ getLabel('addParticipant') }}</a
        >
        <template v-if="participantEmails.length > 0">
          <button
            class="kb-button"
            :data-order="!participantList.length ? 'last' : ''"
            v-on:click="openHoldkaptajnMailudsendelseOverlay($event)"
          >
            {{ getLabel('sendMail') }}
          </button>
        </template>
      </template>
    </div>
    <div class="kb-accordion kb-holdets-deltagere--accordion-modifier">
      <template v-for="(participant, index) in participantList" :key="index">
        <h3 class="kb-accordion__question">
          <svg
            viewBox="0 0 705 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M705 1H2a1 1 0 0 0-1 1v9" stroke="#BFBFB7" />
          </svg>
          <button
            @keydown.tab="tabTrap"
            :data-order="index + 1 === participantList.length ? 'last' : index"
            :id="`teamacc${index}`"
            :aria-controls="`teamanswer${index}`"
            aria-expanded="false"
            v-on:click="toggleAccordion"
          >
            {{ getParticipantFullName(participant) }}
            <div
              class="kb-accordion__question__chevron kb-ui-icon kb-ui-icon--ui-chevron-down"
            ></div>
          </button>
        </h3>
        <div
          class="kb-accordion__answer kb-holdets-deltagere--hidden"
          :id="`teamanswer${index}`"
          role="region"
          :aria-labelledby="`teamacc${index}`"
        >
          <table class="kb-holdets-deltagere__donation-table">
            <tr>
              <th scope="row">{{ getLabel('totalAmount') }}</th>
              <td>{{ formatInt(participant.totalAmountCollected) }}</td>
            </tr>

            <tr>
              <th scope="row">{{ getLabel('participantFee') }}</th>
              <td>{{ formatInt(participant.deltagerFeeAmount) }}</td>
            </tr>

            <tr>
              <th scope="row">{{ getLabel('lights') }}</th>
              <td>{{ formatInt(participant.lysposerCount) }}</td>
            </tr>

            <tr>
              <th scope="row">{{ getLabel('donations') }}</th>
              <td>{{ formatInt(participant.donationAmount) }}</td>
            </tr>
          </table>
          <div class="kb-holdets-deltagere__support-links">
            <a :href="getDonateToParticipantUrl(participant)" class="kb-button kb-button--full-color">
              {{ supportParticipantLabel('support', participant) }}
            </a>
            <a :href="getLysposeToParticipantUrl(participant)" class="kb-button kb-button">
              {{ supportParticipantLabel('supportWithLight', participant) }}
            </a>
          </div>
        </div>
      </template>
    </div>
  </article>
</template>
